import {StandardHeader} from 'ui-library/reactflow/nodes/BenchlingNode/standard/StandardHeader';
import {StandardNode} from 'ui-library/reactflow/nodes/BenchlingNode/standard/StandardNode';
import {StandardSection} from 'ui-library/reactflow/nodes/BenchlingNode/standard/StandardSection';
import {StandardSectionRow} from 'ui-library/reactflow/nodes/BenchlingNode/standard/StandardSectionRow';
import {StandardSections} from 'ui-library/reactflow/nodes/BenchlingNode/standard/StandardSections';

export const StandardBenchlingNode = {
  /**
   * A standard header for a {@link BenchlingNode}. It consumes the context provided by
   * {@link BenchlingNode}, and as such automatically handles node status and disabled status.
   */
  Header: StandardHeader,
  /** A standard flowchart node. */
  Node: StandardNode,
  /**
   * A standard wrapper for sections within a {@link BenchlingNode}. It consumes the context provided by
   * {@link BenchlingNode}, and as such automatically handles section row counts.
   */
  Sections: StandardSections,
  /**
   * A standard section for a {@link BenchlingNode}. It consumes and updates the context provided by
   * {@link BenchlingNode}.
   */
  Section: StandardSection,
  /** A standard section row for a {@link BenchlingNode}. */
  SectionRow: StandardSectionRow,
};
